import { render, staticRenderFns } from "./shortcuts.vue?vue&type=template&id=0fb77196&"
import script from "./shortcuts.vue?vue&type=script&lang=js&"
export * from "./shortcuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports